








import { defineComponent, PropType } from "@vue/composition-api";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import { resolveUserName } from "@/lib/userHelpers";
import TransactionView from "../TransactionView.vue";

export default defineComponent({
  name: "TransactionFundraisingGoalTip",
  components: { TransactionView },
  props: {
    transaction: { type: Object as PropType<Transaction>, required: true },
  },
  setup() {
    return {
      resolveUserName,
    };
  },
});
